export default {
  caseStudies: {
    page: {
      tagline: 'Histoires de réussite de nos clients',
      headline: 'Des résultats concrets de',
      headlineHighlight: 'vraies équipes de livraison',
      description:
        'Découvrez comment des équipes de livraison et de logistique — restaurants, pharmacies, épicerie, courrier et colis, e-commerce et 3PL — utilisent Geofleet pour rationaliser la dernière mile, réduire les coûts et fidéliser les clients.',
    },
    featured: { label: 'Histoire de réussite à la une' },
    filters: {
      label: 'Filtrer par secteur',
      allIndustries: 'Tous les secteurs',
      ariaLabel: 'Filtrer les études de cas par secteur',
    },
    list: {
      title: 'Histoires clients',
      defaultSubtitle: 'Défis réels, solutions concrètes, résultats mesurables pour les équipes de livraison',
      countInIndustry_one: '{{count}} histoire dans ce secteur',
      countInIndustry_other: '{{count}} histoires dans ce secteur',
      story_one: '{{count}} histoire',
      story_other: '{{count}} histoires',
    },
    empty: {
      title: 'Aucune histoire dans ce secteur',
      hint: 'Essayez de sélectionner un autre filtre sectoriel.',
    },
    card: { readFullStory: 'Lire l\'histoire complète' },
    explore: { badge: 'Comment explorer' },
    cta: {
      title: 'Prêt à écrire votre histoire de réussite ?',
      subtitle: 'Rejoignez les équipes de livraison qui obtiennent des résultats similaires avec Geofleet.',
    },
    detail: {
      schemaSection: 'Étude de cas',
      backLink: 'Toutes les études de cas',
      challengeHeading: 'Le défi',
      solutionHeading: 'La solution',
      analytics: { metric: 'Indicateur', before: 'Avant', after: 'Après' },
      timelineTitle: 'Calendrier de mise en œuvre',
      keyTakeaways: 'Points clés',
      relatedTitle: 'Études de cas connexes',
      exploreSolution: {
        badge: 'Explorer la solution',
        title: 'Découvrez comment Geofleet fonctionne pour {{industry}}',
      },
      cta: {
        title: 'Obtenez des résultats similaires',
        subtitle: 'Découvrez comment Geofleet peut aider votre équipe. Commencez dès maintenant ou réservez une démo personnalisée.',
      },
    },
  },
};
